/**
 * Client mirror of functions-forms/src/shared/tiers.ts isTrialCurrentlyActive.
 * Keep in sync when server logic changes.
 */

export function getTrialEndMs(trialEndDate) {
  if (!trialEndDate) return null;
  if (trialEndDate instanceof Date) return trialEndDate.getTime();
  if (typeof trialEndDate.toDate === 'function') return trialEndDate.toDate().getTime();
  if (trialEndDate.seconds != null || trialEndDate._seconds != null) {
    const sec = trialEndDate.seconds ?? trialEndDate._seconds;
    return sec * 1000;
  }
  if (typeof trialEndDate === 'string' || typeof trialEndDate === 'number') {
    return new Date(trialEndDate).getTime();
  }
  return null;
}

export function isTrialCurrentlyActive(userProfile) {
  if (!userProfile?.trialActive || !userProfile?.trialEndDate) return false;
  if (userProfile.subscriptionStatus === 'active' && userProfile.subscriptionId) return false;
  const endMs = getTrialEndMs(userProfile.trialEndDate);
  if (endMs == null || !Number.isFinite(endMs)) return false;
  return endMs > Date.now();
}
